<template>
    <!-- Navbar Start -->
    <div class="container-fluid sticky-top">
        <div class="container">
            <nav class="navbar navbar-expand-lg navbar-light p-0">
                <a :href="`/${username || ''}`" class="navbar-brand"><img src="assets/img/logo-australian-made.png" class="w-100 my-2"/>
                    <!-- <h2 class="text-white">BIO NAD+ BOOST</h2> -->
                </a>
                <button
                    type="button"
                    class="navbar-toggler ms-auto me-0 border-0"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#navbarCollapse">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="offcanvas offcanvas-end" id="navbarCollapse">
                    <div class="offcanvas-header">
                        <h5 class="offcanvas-title text-warning" id="offcanvasNavbarLabel">BIO NAD+ BOOST</h5>
                        <a class="" data-bs-dismiss="offcanvas" aria-label="Close">
                            <i class="fa-solid fa-xmark fa-shake fa-xl" style="color: #ffffff;"></i>
                        </a>
                    </div>
                    <div
                        class="offcanvas-body"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#navbarCollapse">
                        <div class="navbar-nav">
                            <a :href="`/${username || ''}`" class="nav-item nav-link active">{{ headerComp.home }}</a>
                            <a href="#about" class="nav-item nav-link">{{ headerComp.about }}</a>
                            <a href="#benefit" class="nav-item nav-link">{{ headerComp.promo }}</a>
                            <a href="#dnarepair1" class="nav-item nav-link">{{ headerComp.video }}</a>
                            <a href="#testi" class="nav-item nav-link">{{ headerComp.testi }}</a>
                            <a href="#contact" class="nav-item nav-link">{{ headerComp.contact }}</a>
                        </div>
                    </div>
                </div>
                <div class="nav-item dropdown">
                    <a
                        class="nav-link dropdown-toggle hidden-arrow d-flex align-items-center"
                        href="#"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <img
                            v-bind:src="'assets/img/' + flagImage"
                            class="rounded-circle"
                            height="25"
                            alt=""
                            loading="lazy"/>
                    </a>
                    <div class="dropdown-menu mt-2" style="min-width:25px">
                        <a href="#" class="dropdown-item px-2"><img v-on:click="gantiBahasa('id')" src="assets/img/flag-id.png" height="25"/></a>
                        <a href="#" class="dropdown-item px-2"><img v-on:click="gantiBahasa('en')" src="assets/img/flag-en.png" height="25"/></a>
                    </div>
                </div>
            </nav>
        </div>
    </div>
    <!-- Navbar End -->
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'HeaderComp',

        data() {
            return {
                username: null,
                flagImage: "flag-id.png",
                showNavbar: false,
                lastScrollPosition: 0,
                headerComp: {
                    home: null,
                    about: null,
                    promo: null,
                    contact: null,
                    video: null,
                    testi: null
                }
            }
        },

        mounted() {
            // this.username = window.location.pathname.replace("/", "");
            this.username = this.$route.params.username

            if (localStorage.getItem('lang_nad') == null) {
                localStorage.setItem('lang_nad', 'id')
                this.flagImage = 'flag-id.png'
            } else if (localStorage.getItem('lang_nad') == 'id') {
                this.flagImage = 'flag-id.png'
            } else if (localStorage.getItem('lang_nad') == 'en') {
                this.flagImage = 'flag-en.png'
            }

            axios
                .get(`../../lang.json`)
                .then(response => {
                    let dataheaderComp
                    if (localStorage.getItem('lang_nad') == 'id') {
                        dataheaderComp = response
                            .data
                            .id[0];
                    } else if (localStorage.getItem('lang_nad') == 'en') {
                        dataheaderComp = response
                            .data
                            .en[0];
                    }
                    this.headerComp.home = dataheaderComp.headerComp.home
                    this.headerComp.about = dataheaderComp.headerComp.about
                    this.headerComp.promo = dataheaderComp.headerComp.promo
                    this.headerComp.video = dataheaderComp.headerComp.video
                    this.headerComp.testi = dataheaderComp.headerComp.testi
                    this.headerComp.contact = dataheaderComp.headerComp.contact
                })

            window.addEventListener('scroll', this.onScroll)
        },

        // beforeDestroy () { window.removeEventListener('scroll', this.onScroll) },

        methods: {
            gantiBahasa() {
                if (localStorage.getItem('lang_nad') == 'id') {
                    localStorage.setItem('lang_nad', 'en')
                    this.flagImage = 'flag-en.png'
                } else if (localStorage.getItem('lang_nad') == 'en') {
                    localStorage.setItem('lang_nad', 'id')
                    this.flagImage = 'flag-id.png'
                }
                location.reload()
            }
        }
    }
</script>